import moment from 'moment'

export default {
  create (VueApp, callback) {
    let user = VueApp.$store.state.corporate.profile.info
    let countryCode = VueApp.$store.state.countryCode.callingCode
    VueApp.$sdk.post('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      name: user.name,
      username: user.username,
      password: user.password,
      contactEmail: user.email,
      contactPhone: '+' + countryCode + user.mobile,
      billingAddress1: user.billingAddress1,
      billingAddress2: user.billingAddress2,
      billingCity: user.billingCity,
      billingState: user.billingState,
      billingZip: user.billingZip,
      billingCountry: user.biilingCountry,
      logoUrl: user.logo,
      corporateColor: user.color,
      corporateWebsiteUrl: user.website,
      active: 1,
      countryCode: countryCode,
      nationalNumber: user.mobile
    }, res => {
      callback(res)
    })
  },
  getInfo (VueApp, id, callback) {
    VueApp.$sdk.get('/admin/corporateprofile', {
      token: VueApp.$store.state.session.sessionToken,
      orderAsc: 0,
      order: 'created',
      pageSize: 2,
      pageNum: 1,
      id: id
    }, res => {
      callback(res)
    })
  },
  update (VueApp, callback) {
    let user = VueApp.$store.state.corporate.profile.info
    let countryCode = VueApp.$store.state.countryCode.callingCode
    VueApp.$sdk.post('/admin/corporateprofile/' + user.id, {
      token: VueApp.$store.state.session.sessionToken,
      name: user.name,
      username: user.username,
      contactEmail: user.email,
      contactPhone: '+' + countryCode + user.mobile,
      billingAddress1: user.billingAddress1,
      billingAddress2: user.billingAddress2,
      billingCity: user.billingCity,
      billingState: user.billingState,
      billingZip: user.billingZip,
      billingCountry: user.biilingCountry,
      logoUrl: user.logo,
      corporateColor: user.color,
      corporateWebsiteUrl: user.website,
      discountCode: user.discountCode,
      countryCode: countryCode,
      nationalNumber: user.mobile
    }, res => {
      callback(res)
    })
  },
  toggleStatus (VueApp, data, callback) {
    let user = VueApp.$store.state.corporate.profile.info
    VueApp.$sdk.post('/admin/corporateprofile/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      active: data.active ? 0 : 1
    }, res => {
      callback(res)
    })
  },
  getAllTransactions (VueApp, id, callback) {
    // let self = this
    let tableData = VueApp.$store.state.corporate.invoice
    // let pageSize = tableData.perPage
    // let page = tableData.currentPage
    let since = moment(tableData.dateFrom, 'MM/DD/YYYY').format('YYYY-MM-DD 00:00')
    let until = moment(tableData.dateTo, 'MM/DD/YYYY').format('YYYY-MM-DD 23:59')

    VueApp.$sdk.get('/admin/corporateprofile/' + id + '/invoice', {
      token: VueApp.$store.state.session.sessionToken,
      pageSize: 999,
      pageNum: 1,
      order: 'created',
      orderAsc: 0,
      completeSince: since,
      completeUntil: until
    }, res => {
      callback(res)
    })
  },
  bookedThroughLabel (value) {
    switch (value) {
      case 'ww': return 'Web'
      case 'admin': return 'Admin'
      case 'android': return 'Android App'
      case 'ios': return 'iOS App'
      case 'provider': return 'Provider'
      default: return value
    }

    return ''
  },
  toFixed (value) {
    value = parseFloat(value)
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2)
    }
    return '$' + value.toFixed(2)
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/corporate/profile.js